import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileIcon',
    standalone: true,
})
export class FileIconPipe implements PipeTransform {
    transform(mime: string): any {
        switch (mime) {
            case 'application/pdf':
                return 'picture_as_pdf';
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            case 'application/msword':
                return 'description';
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            case 'application/vnd.ms-excel':
                return 'functions';
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            case 'application/vnd.ms-powerpoint':
                return 'slideshow';
            case 'application/zip':
            case 'application/x-rar-compressed':
                return 'folder_zip';
            case 'image/png':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/webp':
                return 'imagesmode';
            case 'audio/mpeg':
            case 'audio/mp4':
            case 'audio/ogg':
            case 'audio/wav':
            case 'audio/webm':
                return 'music_note';
            case 'video/mp4':
            case 'video/ogg':
            case 'video/webm':
                return 'videocam';
            default:
                return 'content_copy';
        }
    }
}
